import { Component, Input, OnInit } from '@angular/core';
import { AlertsService } from '../../services/alerts.service';
import { AppFilter } from '@app/shared/models';

@Component({
  selector: 'app-alert-notifications',
  templateUrl: './alert-notifications.component.html',
  styleUrls: ['./alert-notifications.component.scss'],
})
export class AlertNotificationsComponent implements OnInit {
  constructor(private alertSvc: AlertsService) {}
  alertNotifications: any[] = [];

  totalItems = 0;
  rows = 10;
  maxSize = 10;
  currentPage = 1;
  pending: boolean;
  success;
  error;

  data = [
    {
      action: 'Failed Login Attempts',
      description: 'Real-time alerts for multiple failed login attempts',
      notificationName: 'slackChanel 001',
      notificationType: 'Slack',
      addedBy: 'Tolulope idris',
      dateAdded: '17 Oct, 2020, 5:15PM',
    },
    {
      action: 'Failed Login Attempts',
      description: 'Real-time alerts for multiple failed login attempts',
      notificationName: 'slackChanel 001',
      notificationType: 'Slack',
      addedBy: 'Tolulope idris',
      dateAdded: '17 Oct, 2020, 5:15PM',
    },
  ];

  searchFilter = {
    groupOp: 'OR',
    rules: [
      {
        field: 'description',
        op: 'cn',
        data: '',
      },
    ],
  };

  getPage(pageNumber: number) {
    this.filter.page = pageNumber;
    this.getAlertNotifications();
    this.pageChange = true;
  }

  pageChange: boolean;
  nextPage(pageNumber: number) {
    this.filter.page = pageNumber;
    this.getAlertNotifications();
    this.pageChange = true;
  }

  resetPageChange() {
    this.pageChange = false;
  }

  cancelAd() {
    this.filter = new AppFilter({
      page: 1,
      rows: this.rows,
      _search: false,
    });

    this.getAlertNotifications();
  }

  advancedSearch(e) {
    if (e) {
      this.filter._search = true;
      this.filter.filters = JSON.stringify(e);
    } else {
      this.filter.filters = {};
      this.filter._search = false;
    }
    this.filter.page = 1;
  }

  sortRecords(search) {
    this.filter.sord = search;
    this.filter.page = 1;
    this.getAlertNotifications();
  }
  headerFilters = [];
  headers = [];

  searchRecords(e) {
    this.searchFilter.rules[0].data = e;
    this.filter._search = true;

    this.filter.filters = JSON.stringify(this.searchFilter);
    this.filter.page = 1;
    this.getAlertNotifications();
  }

  displayRecords(e) {
    this.filter['rows'] = e;
    this.currentPage = 1;

    this.getAlertNotifications();
  }

  filter = new AppFilter({ sidx: 'dateTriggered', _search: false });

  getAlertNotifications() {
    this.pending = true;
    this.alertSvc.getAlertNotifications(this.filter).subscribe(
      (res: any) => {
        this.pending = false;
        this.alertNotifications = res.rows;

        this.getNotificationPreferences();

        this.totalItems = +res.records;
      },
      (error) => {
        this.error = error.error.errorMessage
          ? error.error.errorMessage
          : error.error.error
          ? error.error.error
          : error.error
          ? error.error
          : error.message
          ? error.message
          : error;
        this.pending = false;
      }
    );
  }

  notificationPreferencesLoading = false;
  notificationPreferencesFilter = new AppFilter({ rows: 1000 });
  slackPreferences = [];
  emailPreferences = [];
  notificationPreferences = [];
  notificationPreferencesLoaded = false;

  getNotificationPreferences() {
    this.notificationPreferencesLoading = true;
    this.alertSvc
      .getNotificationPreferences(this.notificationPreferencesFilter)
      .subscribe(
        (res: any) => {
          this.notificationPreferences = res.rows.map(
            (notificationPreference) => {
              let parsedPreference = JSON.parse(
                notificationPreference.settings
              );
              if (parsedPreference.notificationType === 'email') {
                this.emailPreferences.push({
                  settingId: notificationPreference.settingId,
                  ...parsedPreference,
                });
              } else if (parsedPreference.notificationType === 'slack') {
                this.slackPreferences.push({
                  settingId: notificationPreference.settingId,
                  ...parsedPreference,
                });
              }
              return {
                settingId: notificationPreference.settingId,
                ...parsedPreference,
              };
            }
          );

          for (let i = 0; i < this.alertNotifications.length; i++) {
            let alertConfiguration = JSON.parse(
              this.alertNotifications[i].configuration
            );
            let addendum = [];

            if (alertConfiguration?.notificationSettings.length) {
              for (
                let j = 0;
                j < alertConfiguration.notificationSettings.length;
                j++
              ) {
                for (let k = 0; k < this.notificationPreferences.length; k++) {
                  if (
                    alertConfiguration.notificationSettings[j] ===
                    this.notificationPreferences[k].settingId
                  ) {
                    addendum.push({
                      ...this.notificationPreferences[k],
                    });
                  }
                }
              }
            }
            this.alertNotifications[i] = {
              ...this.alertNotifications[i],
              notificationSettings: addendum,
            };
          }

          this.notificationPreferencesLoading = false;
          this.notificationPreferencesLoaded = true;
        },
        (error) => {
          this.notificationPreferencesLoading = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error.message
            ? error.message
            : error;
        }
      );
  }

  ngOnInit(): void {
    this.getAlertNotifications();
  }
}
